export default "__VITE_ASSET__IladWqj8__"